export default __webpack_public_path__ + "static/media/ally_s3.64abec7f.png";